import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { InterventionFiltersState, InterventionFiltersActions } from './types'

const initialState: InterventionFiltersState = {
  activeFilters: {},
  draftFilters: {},
  isDrawerOpen: false,
}

export const useInterventionFiltersStore = create<
  InterventionFiltersState & InterventionFiltersActions
>()(
  devtools(
    (set, get) => ({
      ...initialState,

      setActiveFilters: (filters) => {
        set({ activeFilters: filters })
      },

      setDraftFilters: (filters) => {
        set({ draftFilters: filters })
      },

      updateDraft: (updates) => {
        set((state) => ({
          draftFilters: { ...state.draftFilters, ...updates },
        }))
      },

      apply: () => {
        const { draftFilters } = get()
        set({
          activeFilters: { ...draftFilters },
          isDrawerOpen: false,
        })
      },

      clear: () => {
        set({
          activeFilters: {},
          draftFilters: {},
          isDrawerOpen: false,
        })
      },

      openDrawer: () => {
        const { activeFilters } = get()
        set({ draftFilters: activeFilters, isDrawerOpen: true })
      },

      closeDrawer: () => {
        set({ isDrawerOpen: false })
      },

      reset: () => {
        set(initialState)
      },
    }),
    {
      name: 'InterventionFiltersStore',
    }
  )
)
